import { sgg } from 'ml-savitzky-golay-generalized';
/**
 * Apply the Savitzky Golay Generalized Filter
 * @param data
 * @param options
 */
export function savitzkyGolay(data, options = {}) {
    const { x, y } = data;
    return { data: { x, y: sgg(y, x, options) } };
}
//# sourceMappingURL=savitzkyGolay.js.map